import React from "react";

const UserFormContext = React.createContext();

export default UserFormContext;